import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Flex, Result, Steps, Upload } from 'antd';
import { FileOutlined, InboxOutlined, SmileOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import useHistory from '../../../../hooks/navigation/useHistory';
import useApiClient from '../../../../hooks/api/useApiClient';
import { Utils } from '../../../../services/helpers/Utils';
import { ScreenEnum } from '../../../../hooks/navigation/Screens';

function UploadStep({ onComplete }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Views:Marketing:Followers:Import:UploadStep' });

  const { CustomersManager } = useApiClient();

  const uploadFile = async (e) => {
    const { file } = e;

    const { success, data } = await CustomersManager.import(
      Utils.createFormData({
        file,
      }),
    );

    if (!success) {
      return toast.error(t('toasts.error'));
    }

    return onComplete(data);
  };

  return (
    <div>
      <Upload.Dragger
        name="file"
        accept="text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        customRequest={uploadFile}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">{t('title')}</p>
        <p className="ant-upload-hint">{t('description')}</p>
      </Upload.Dragger>
      <Flex justify="end" className="mt-md">
        <a href="/docs/customer_import_template.csv" target="_blank" rel="noreferrer">
          {t('buttons.download_template')}
        </a>
      </Flex>
    </div>
  );
}

export const ValidationStatus = {
  Valid: 'valid',
  HasInvalidContent: 'has_invalid_content',
  Invalid: 'invalid',
};

function FinishStep() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Views:Marketing:Followers:Import:FinishStep' });

  const history = useHistory();

  return (
    <Result
      status="success"
      title={t('title')}
      subTitle={t('description')}
      extra={
        <Button onClick={() => history.push(ScreenEnum.MarketingFollowers)}>{t('buttons.open_followers_list')}</Button>
      }
    />
  );
}

export default function FollowersImportView() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Views:Marketing:Followers:Import' });

  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    {
      title: t('steps.upload'),
      icon: <FileOutlined />,
      content: <UploadStep onComplete={() => setCurrentStep(1)} />,
    },
    {
      title: t('steps.finish'),
      icon: <SmileOutlined />,
      content: <FinishStep />,
    },
  ];

  return (
    <>
      <h2>
        <Link to={`${ScreenEnum.MarketingFollowers}`}>{t('title')}</Link>
        {` / ${t('labels.import')}`}
      </h2>
      <Steps current={currentStep} className="mt-lg" items={steps} />
      <div className="mt-xl">{steps[currentStep].content}</div>
    </>
  );
}
